import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import LinearProgress from "@mui/material/LinearProgress";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Tooltip as ReactTooltip } from "react-tooltip";

const DownloadBar = ({
  imageUrl,
  onDownloadClick,
  onCancel,
  preparingDownload,
  renderStarted,
}) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (copied) {
      const t = setTimeout(() => setCopied(false), 1000);
      return () => clearTimeout(t);
    }
  }, [copied]);

  const handleCopy = () => {
    if (!navigator.clipboard) {
      const textArea = document.createElement("textarea");
      textArea.value = imageUrl;
      textArea.style.cssText = "position:fixed;top:0;left:0";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand("copy");
        setCopied(true);
      } catch (err) {
        console.error("Fallback copy failed", err);
      }
      document.body.removeChild(textArea);
      return;
    }
    navigator.clipboard
      .writeText(imageUrl)
      .then(() => setCopied(true))
      .catch((err) => {
        alert("Failed to copy text");
        console.error(err);
      });
  };

  return (
    <div className="download-image-popup--container">
      <div style={{ display: "flex", alignItems: "center", gap: 10, opacity: renderStarted ? 0 : 1 }}>
        <div className="download-image-popup--image-container">
          <img className="download-image-popup--image" src={imageUrl} alt="render" />
        </div>
        <div className="text-center" style={{ fontSize: "95%" }}>
          Image.png
        </div>
      </div>

      <ReactTooltip anchorSelect=".click-to-copy" id="il-tooltip" style={{ zIndex: 1000, marginTop: 16 }} />

      <div
        className={renderStarted ? "click-to-copy" : "copy-container click-to-copy"}
        onClick={renderStarted ? undefined : handleCopy}
        data-tooltip-id="il-tooltip"
        data-tooltip-content={copied ? "Copied" : "This URL will be valid for 5 days. Click to copy."}
        data-tooltip-place="top"
      >
        {!renderStarted && (
          <ContentCopyIcon className="copy-container-icon" sx={{ padding: 0.3 }} />
        )}
        {!renderStarted && (
          <div className="copy-container--text">{imageUrl}</div>
        )}
      </div>

      <div
        style={{
          display: renderStarted ? "flex" : "none",
          flexDirection: "column",
          width: "100%",
          fontSize: 18,
          paddingBottom: 4,
          gap: 20,
        }}
      >
        {renderStarted && <div style={{ textAlign: "center" }}>Rendering Image...</div>}
        {renderStarted && <LinearProgress sx={{ width: "100%" }} />}
      </div>

      <div
        className="download-image-popup--button-container"
        style={{ opacity: renderStarted ? 0 : 1 }}
      >
        {!preparingDownload && (
          <Button
            variant="contained"
            sx={{
              textTransform: "capitalize",
              color: "red",
              backgroundColor: "white",
              "&:hover": { backgroundColor: "white", width: "auto" },
            }}
            onClick={onCancel}
          >
            <span className="bannerdec3">Cancel</span>
          </Button>
        )}
        <Button
          variant="contained"
          sx={{
            textTransform: "capitalize",
            "&:hover": { backgroundColor: "white", color: "#1976d2", width: "auto" },
          }}
          onClick={preparingDownload ? undefined : onDownloadClick}
        >
          <span className="bannerdec3">
            {preparingDownload ? "Downloading..." : "Download"}
          </span>
        </Button>
      </div>
    </div>
  );
};

export default DownloadBar;
